export default __webpack_public_path__ + "static/wokkel-7d10e6fb9d05aa6c276746d7591fdf56.png";